'use client';

import React from 'react';
import { useTheme } from '@mui/material/styles';
import errorCode from 'http-status';
import { useTranslation } from '@local/i18n/infrastructure/i18next/client';
import IllustratedMessage from '@almacareer/profesiaui/components/common/IllustratedMessage';
import Text from '@almacareer/profesiaui/components/common/Typography/Text';
import {
    TitleFontSize,
    TitleFontVariant,
} from '@almacareer/profesiaui/components/common/Typography/types';
import { getColor } from '@almacareer/profesiaui/styles/colors';
import Telescope from '@local/common/ui/components/icons/multiColor/Telescope';
import Button from '@almacareer/profesiaui/components/common/Button/Button';
import { ButtonVariant } from '@almacareer/profesiaui/components/common/Button/types';
import { getProfesiaRedirectPath } from '@local/router/infrastructure/common/createPath';

export interface IllustratedErrorMessageProps {
    statusCode:
        | typeof errorCode.BAD_REQUEST
        | typeof errorCode.NOT_FOUND
        | typeof errorCode.INTERNAL_SERVER_ERROR;
}

const IllustratedErrorMessage = ({ statusCode }: IllustratedErrorMessageProps) => {
    const { t } = useTranslation();
    const { palette } = useTheme();
    const handleRedirectToHomepage = () => {
        window.location.href = getProfesiaRedirectPath('');
    };

    return (
        <IllustratedMessage
            title={t(`illustratedMessage.error.heading.${statusCode}`)}
            titleProps={{
                fontSize: TitleFontSize.Large,
                fontVariant: TitleFontVariant.Emphasis,
                component: 'h1',
            }}
            illustration={<Telescope data-testid="telescope-image" />}
            action={
                <Button variant={ButtonVariant.PrimaryAlt} onClick={handleRedirectToHomepage}>
                    {t('illustratedMessage.error.action.goToHomePage')}
                </Button>
            }
        >
            <Text>{t(`illustratedMessage.error.errorInstructions.${statusCode}`)}</Text>

            <Text color={getColor(palette.textPlaceholder)}>
                {t('illustratedMessage.error.errorCode')}: {statusCode}
            </Text>
        </IllustratedMessage>
    );
};

export default IllustratedErrorMessage;
